module.exports = __webpack_public_path__ + "static/media/MuscleMilk.4c80a624.svg";